import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const StrikesDownSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 13L11.995 18L17 13M7 7L11.995 12L17 7" stroke="currentColor" strokeLinecap="round"/>
    </svg>
)
const StrikesDownIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {StrikesDownSvg}
    </SvgIcon>
);
export default StrikesDownIcon
